/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import FilterRegularReport from './filter-regular-report-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <FilterRegularReport {...validProps} />;
}

SvgComponent.iconName = 'filterRegularReport';

export const FilterRegularReportIcon = svgIconWrapper(SvgComponent);
